import React, { useEffect, useState } from 'react'
import { motion } from 'framer-motion';
import '../Home/Home.css';

const ROLE = "Full Stack Developer";

export default function Home() {
  const [typed, setTyped] = useState('');
  const [showCursorBlink, setShowCursorBlink] = useState(true);

  useEffect(() => {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) {
      setTyped(ROLE);
      return;
    }
    let i = 0;
    const interval = setInterval(() => {
      i += 1;
      setTyped(ROLE.slice(0, i));
      if (i >= ROLE.length) {
        clearInterval(interval);
      }
    }, 55);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const blink = setInterval(() => setShowCursorBlink((v) => !v), 600);
    return () => clearInterval(blink);
  }, []);

  return (
    <section className="home-section d-flex align-items-center" id="home">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="container profile-container"
      >
        <div className="terminal-window">
          <div className="terminal-bar">
            <span className="dot dot-red"></span>
            <span className="dot dot-yellow"></span>
            <span className="dot dot-green"></span>
            <span className="terminal-path">sathuragiri@portfolio: ~</span>
          </div>
          <div className="terminal-body">
            <p className="terminal-line">
              <span className="terminal-prompt">$</span> whoami
            </p>
            <h1 className="terminal-name">Sathuragiri SB</h1>
            <p className="terminal-line terminal-role">
              <span className="terminal-prompt">$</span> {typed}
              <span className={`terminal-cursor ${showCursorBlink ? 'visible' : ''}`}>_</span>
            </p>
            <p className="terminal-status">
              <span className="status-dot"></span>
              Open to new opportunities
            </p>
          </div>
        </div>

        <div className="mt-4 hero-actions">
          <a
            href="https://www.linkedin.com/in/sathuragiri22/"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-outline-primary me-3 hero-btn"
          >
            LinkedIn
          </a>
          <a href="/Sathuragiriresume.pdf" className="btn btn-outline-primary me-3 hero-btn" download>Resume</a>
        </div>
      </motion.div>
    </section>
  )
}
